export const DEVICE_TYPES = {
	NTR: 'ECOLOG-PRO 1NTR',
	PTR: 'ECOLOG-PRO 2PTR',
	THR: 'ECOLOG-PRO 1THR',
	LIBERO_GS: 'LIBERO GS',
	LIBERO_GF: 'LIBERO GF',
	LIBERO_GL: 'LIBERO GL',
	LIBERO_GE: 'LIBERO GE',
	LIBERO_GH: 'LIBERO GH',
	LIBERO_GF_EXT: 'LIBERO GF ext',
	ECOLOG_PRO_1TGi: 'ECOLOG-PRO 1TGi',
	ECOLOG_PRO_1THGi: 'ECOLOG-PRO 1THGi',
	ECOLOG_PRO_1TGe: 'ECOLOG-PRO 1TGe',
};
